(function () {
  'use strict';

  var SWATCH_INPUT_SELECTOR =
    '.collection-product-card__swatch input[type="radio"][data-variant-id]';
  var VARIANTS_CONTAINER_SELECTOR = '.collection-product-card__variants';
  var VARIANTS_WRAPPER_SELECTOR = '.collection-product-card__variants-wrapper';
  var rafAll = null;
  var mutationObserver = null;

  function buildImageUrl(imageUrl, width) {
    if (!imageUrl) return '';

    try {
      var url = new URL(imageUrl, window.location.href);
      url.searchParams.set('width', width);
      return url.toString();
    } catch (error) {
      var separator = imageUrl.indexOf('?') === -1 ? '?' : '&';
      return imageUrl + separator + 'width=' + width;
    }
  }

  function updateProductCardFromSwatch(input) {
    var card = input.closest('.card-product-custom-div');
    if (!card) return;

    var variantImageUrl = input.getAttribute('data-variant-image-url');
    var productUrl = input.getAttribute('data-product-url');

    if (variantImageUrl) {
      var productImageElement = card.querySelector('.card__media img');

      if (productImageElement) {
        var widths = [165, 360, 533, 720, 940, 1066];
        var dynamicSrcset = widths
          .map(function (width) {
            return buildImageUrl(variantImageUrl, width) + ' ' + width + 'w';
          })
          .join(', ');

        productImageElement.srcset = dynamicSrcset;
        productImageElement.src = buildImageUrl(variantImageUrl, 533);
      }
    }

    if (productUrl) {
      var productLinks = card.querySelectorAll(
        'a[id^="CardLink-"], a[id^="StandardCardNoMediaLink-"]'
      );

      productLinks.forEach(function (link) {
        link.href = productUrl;
      });
    }
  }

  function updateNavButtons(wrapper) {
    if (!wrapper) return;

    var container = wrapper.querySelector(VARIANTS_CONTAINER_SELECTOR);
    var prevBtn = wrapper.querySelector('.swatch-prev');
    var nextBtn = wrapper.querySelector('.swatch-next');

    if (!container || !prevBtn || !nextBtn) return;

    var hasOverflow = container.scrollWidth > container.clientWidth + 1;

    prevBtn.style.display = hasOverflow ? 'block' : 'none';
    nextBtn.style.display = hasOverflow ? 'block' : 'none';

    if (!hasOverflow) {
      prevBtn.classList.add('disabled');
      nextBtn.classList.add('disabled');
      return;
    }

    var atStart = container.scrollLeft <= 1;
    var atEnd =
      container.scrollLeft + container.clientWidth >= container.scrollWidth - 1;

    prevBtn.classList.toggle('disabled', atStart);
    nextBtn.classList.toggle('disabled', atEnd);
  }

  function updateAllNavButtons() {
    document.querySelectorAll(VARIANTS_WRAPPER_SELECTOR).forEach(updateNavButtons);
  }

  function scheduleUpdateAllNavButtons() {
    if (rafAll) return;

    rafAll = window.requestAnimationFrame(function () {
      rafAll = null;
      updateAllNavButtons();
    });
  }

  function scheduleContainerNavUpdate(container) {
    if (!container || container.dataset.ggNavFrame === 'pending') return;

    container.dataset.ggNavFrame = 'pending';

    window.requestAnimationFrame(function () {
      delete container.dataset.ggNavFrame;
      updateNavButtons(container.closest(VARIANTS_WRAPPER_SELECTOR));
    });
  }

  function handleChange(event) {
    var input = event.target.closest(SWATCH_INPUT_SELECTOR);
    if (!input) return;

    updateProductCardFromSwatch(input);
  }

  function handleNavClick(event) {
    var button = event.target.closest('.swatch-nav');
    if (!button || button.classList.contains('disabled')) return;

    var wrapper = button.closest(VARIANTS_WRAPPER_SELECTOR);
    if (!wrapper) return;

    var container = wrapper.querySelector(VARIANTS_CONTAINER_SELECTOR);
    if (!container) return;

    var direction = button.classList.contains('swatch-prev') ? -1 : 1;

    container.scrollBy({
      left: direction * container.clientWidth * 0.4,
      behavior: 'smooth'
    });
  }

  function handleScroll(event) {
    var container = event.target;

    if (
      !container ||
      !container.matches ||
      !container.matches(VARIANTS_CONTAINER_SELECTOR)
    ) {
      return;
    }

    scheduleContainerNavUpdate(container);
  }

  function observeGridChanges() {
    if (!('MutationObserver' in window)) return;

    var gridContainer = document.getElementById('ProductGridContainer');
    if (!gridContainer) return;

    if (mutationObserver) {
      mutationObserver.disconnect();
    }

    mutationObserver = new MutationObserver(function () {
      scheduleUpdateAllNavButtons();
    });

    mutationObserver.observe(gridContainer, {
      childList: true,
      subtree: true
    });
  }

  function initialize() {
    updateAllNavButtons();
    observeGridChanges();
  }

  document.addEventListener('change', handleChange);
  document.addEventListener('click', handleNavClick);
  document.addEventListener('scroll', handleScroll, {
    capture: true,
    passive: true
  });

  window.addEventListener('resize', scheduleUpdateAllNavButtons, {
    passive: true
  });

  document.addEventListener('shopify:section:load', function () {
    initialize();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();